import React from "react";
import { monthConverter } from "utils/common";
import { UserLevel } from "utils/constant";

const TableComponent = ({
  currentLevel,
  reportsData,
  tableRef,
  reportInfo,
}) => {
  const getTotal = (field) => {
    return reportsData.reduce(
      (total, item) => total + Number(item[field] || 0),
      0
    );
  };

  const renderTableByLevel = () => {
    switch (currentLevel) {
      case UserLevel.National:
      case UserLevel.Province:
        return (
          <>
            <thead>
              <tr>
                <th>No.</th>
                {currentLevel === UserLevel.National && (
                  <>
                    <th>Provinsi</th>
                  </>
                )}
                <th>Wilayah</th>
                <th>Jumlah fasyankes/BKK</th>
                <th>Jum fasyankes/BKK melapor data mikroskopis</th>
                <th>Jum fasyankes/BKK tersedia mikroskopis</th>
                <th>Jum mikroskopis dilaporkan</th>
                <th>Jum mikroskopis pns</th>
                <th>Jum mikroskopis atlm</th>
                <th>Jum mikrosopis terlatih</th>
                <th>Jum mikroskopis belum terlatih</th>
                <th>
                  Jum mikroskopis diketahui kompetensinya yg memenuhi syarat
                </th>
                <th>
                  Jum mikroskopis diketahui kompetensinya yg belum memenuhi syarat
                </th>
                <th>Jum mikroskopis yang tidak diketahui kompetensinya</th>
              </tr>
            </thead>
            <tbody>
              {reportsData.length !== 0 ? (
                reportsData?.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    {currentLevel === UserLevel.National && (
                      <>
                        <td>{item?.nm_prop}</td>
                      </>
                    )}
                    <td>{item?.wilayah}</td>
                    <td>{item?.totalfaskes}</td>
                    <td>{item?.faskes_melaporkan}</td>
                    <td>{item?.jumfaskesmikroskopis}</td>
                    <td>{item?.jumya}</td>
                    <td>{item?.stspegawaipns}</td>
                    <td>{item?.pddkatlm}</td>
                    <td>{item?.jummikrosterlatih}</td>
                    <td>{item?.jummikrosbelumterlatih}</td>
                    <td>{item?.jumsesuaisyarat}</td>
                    <td>{item?.jumbthpeningkatan}</td>
                    <td>{item?.jummikrostdkdiketahuikompetensinya}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={17}>Tidak Ada Data</td>
                </tr>
              )}
              <tr style={{ backgroundColor: "#43766C" }}>
                <td
                  style={{ color: "#FFF" }}
                  colSpan={currentLevel === UserLevel.National ? 3 : 2}
                >
                  Total
                </td>
                <td style={{ color: "#FFF" }}>{getTotal("totalfaskes")}</td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("faskes_melaporkan")}
                </td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("jumfaskesmikroskopis")}
                </td>

                <td style={{ color: "#FFF" }}>{getTotal("jumya")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("stspegawaipns")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("pddkatlm")}</td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("jummikrosterlatih")}
                </td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("jummikrosbelumterlatih")}
                </td>
                <td style={{ color: "#FFF" }}>{getTotal("jumsesuaisyarat")}</td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("jumbthpeningkatan")}
                </td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("jummikrostdkdiketahuikompetensinya")}
                </td>
              </tr>
            </tbody>
          </>
        );
      case UserLevel.District:
        return (
          <>
            <thead>
              <tr>
                <th>No.</th>
                <th>Nama fasyankes/BKK</th>
                <th>Fasyankes/BKK melapor</th>
                <th>Jum mikroskopis dilaporkan</th>
                <th>Jum mikroskopis pns</th>
                <th>Jum mikroskopis atlm</th>
                <th>Jum mikrosopis terlatih</th>
                <th>Jum mikroskopis belum terlatih</th>
                <th>
                  Jum mikroskopis diketahui kompetensinya yg memenuhi syarat
                </th>
                <th>
                  Jum mikroskopis diketahui kompetensinya yg belum memenuhi
                  syarat
                </th>
                <th>Jum mikroskopis tidak diketahui kompetensinya</th>
              </tr>
            </thead>
            <tbody>
              {reportsData.length !== 0 ? (
                reportsData?.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item?.nama_fasyankes}</td>
                    <td>{item?.faskesmelapor ?? "0"}</td>
                    <td>{item?.jumya ?? "0"}</td>
                    <td>{item?.stspegawaipns ?? "0"}</td>
                    <td>{item?.pddkatlm ?? "0"}</td>
                    <td>{item?.jummikrosterlatih ?? "0"}</td>
                    <td>{item?.jummikrosbelumterlatih ?? "0"}</td>
                    <td>{item?.jumsesuaisyarat ?? "0"}</td>
                    <td>{item?.jumbthpeningkatan ?? "0"}</td>
                    <td>{item?.jummikrostdkdiketahuikompetensinya ?? "0"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={17}>Tidak Ada Data</td>
                </tr>
              )}
              <tr style={{ backgroundColor: "#43766C" }}>
                <td style={{ color: "#FFF" }} colSpan={2}>
                  Total
                </td>

                <td style={{ color: "#FFF" }}>{getTotal("faskesmelapor")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("jumya")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("stspegawaipns")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("pddkatlm")}</td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("jummikrosterlatih")}
                </td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("jummikrosbelumterlatih")}
                </td>
                <td style={{ color: "#FFF" }}>{getTotal("jumsesuaisyarat")}</td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("jumbthpeningkatan")}
                </td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("jummikrostdkdiketahuikompetensinya")}
                </td>
              </tr>
            </tbody>
          </>
        );
      default:
        return (
          <>
            <thead>
              <tr>
                <th rowSpan={2}>No.</th>
                <th rowSpan={2}>Fasyankes/BKK</th>
                <th rowSpan={2}>Tersedia mikroskopis</th>
                <th rowSpan={2}>Nama mikroskopis</th>
                <th rowSpan={2}>Kepegawaian</th>
                <th rowSpan={2}>NIP / KTP</th>
                <th rowSpan={2}>Tgl lahir</th>
                <th rowSpan={2}>Pendidikan</th>
                <th rowSpan={2}>Tgl mulai bekerja sebagai mikroskopis</th>
                <th rowSpan={2}>Jml pelatihan mikroskopis yang diikuti</th>

                {/* Pelatihan Terakhir */}
                <th colSpan={7} style={{ textAlign: "center" }}>
                  Pelatihan terakhir
                </th>

                {/* Bimtek / Tes Panel Terakhir */}
                <th colSpan={7} style={{ textAlign: "center" }}>
                  Bimtek / tes panel terakhir
                </th>

                {/* Uji Profisiensi */}
                <th colSpan={7} style={{ textAlign: "center" }}>
                  Uji profisiensi terakhir
                </th>

                {/* Uji kompetensi */}
                <th colSpan={3} style={{ textAlign: "center" }}>
                  Uji kompetensi terakhir
                </th>

                {/* Kesimpulan */}
                <th rowSpan={2}>Memenuhi syarat sebagai mikroskopis malaria</th>
                <th rowSpan={2}>Kesimpulan</th>
              </tr>
              <tr>
                {/* Pelatihan Terakhir Sub-columns */}
                <th>Tanggal</th>
                <th>Ada nilai?</th>
                <th>Hasil (Sensitifitas)</th>
                <th>Hasil (Spesifisitas)</th>
                <th>Hasil (Akurasi Spesies)</th>
                <th>Hasil (Hitung Parasit)</th>
                <th>Keterangan nilai</th>

                {/* Bimtek Sub-columns */}
                <th>Tanggal</th>
                <th>Bimtek dg uji panel?</th>
                <th>Hasil (Sensitifitas)</th>
                <th>Hasil (Spesifisitas)</th>
                <th>Hasil (Akurasi Spesies)</th>
                <th>Hasil (Hitung Parasit)</th>
                <th>Keterangan nilai</th>

                {/* Profisiensi */}
                <th>Tanggal</th>
                <th>Hasil</th>
                <th>Hasil (Sensitifitas)</th>
                <th>Hasil (Spesifisitas)</th>
                <th>Hasil (Akurasi Spesies)</th>
                <th>Hasil (Hitung Parasit)</th>
                <th>Keterangan nilai</th>

                {/* Kompetensi */}
                <th>Tanggal</th>
                <th>Hasil</th>
                <th>Keterangan nilai</th>
              </tr>
            </thead>

            <tbody>
              {reportsData.length !== 0 ? (
                reportsData.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item?.nama_fasyankes}</td>
                    <td>{item?.sediamikroskopis}</td>
                    <td>{item?.namapetugas || "-"}</td>
                    <td>{item?.stspegawai || "-"}</td>
                    <td>{item?.nip || "-"}</td>
                    <td>
                      {item?.tlahir
                        ? moment(item?.tlahir).format("YYYY-MM-DD")
                        : null}
                    </td>
                    <td>{item?.pddkan || "-"}</td>
                    <td>
                      {item?.tglmulaikerja
                        ? moment(item?.tglmulaikerja).format("YYYY-MM-DD")
                        : null}
                    </td>
                    <td>{item?.jumplthan || "-"}</td>

                    {/* Pelatihan Terakhir */}
                    <td>
                      {item?.thnplthanakhir
                        ? moment(item?.thnplthanakhir).format("YYYY-MM-DD")
                        : "-"}
                    </td>
                    <td>{item?.nilaiplth}</td>
                    <td>{item?.hslplthsensi || "-"}</td>
                    <td>{item?.hslplthspesi || "-"}</td>
                    <td>{item?.hslplthakurasi || "-"}</td>
                    <td>{item?.hslplthhtungprst || "-"}</td>
                    <td>{item?.hslpelatihan2 || "-"}</td>

                    {/* Bimtek */}
                    <td>
                      {item?.tglbimtekakhir
                        ? moment(item?.tglbimtekakhir).format("YYYY-MM-DD")
                        : "-"}
                    </td>
                    <td>{item?.bimtekpanel || "-"}</td>
                    <td>{item?.hslbimteksensi || "-"}</td>
                    <td>{item?.hslbimtekspesi || "-"}</td>
                    <td>{item?.hslbimtekakurasi || "-"}</td>
                    <td>{item?.hslbimtekhtungprst || "-"}</td>
                    <td>{item?.hslbimtek2 || "-"}</td>

                    {/* Uji Profisiensi */}
                    <td>
                      {item?.tglujiprofis
                        ? moment(item?.tglujiprofis).format("YYYY-MM-DD")
                        : "-"}
                    </td>
                    <td>{item?.hslujiprofis || "-"}</td>
                    <td>{item?.hslprofissensi}</td>
                    <td>{item?.hslprofisspesi}</td>
                    <td>{item?.hslprofisakurasi}</td>
                    <td>{item?.hslprofisparasit}</td>
                    <td>{item?.hslujiprofis2 || "-"}</td>

                    {/* Uji kompetensi */}
                    <td>
                      {item?.tglujikompakhir
                        ? moment(item?.tglujikompakhir).format("YYYY-MM-DD")
                        : "-"}
                    </td>
                    <td>{item?.hslujikompakhir2 || "-"}</td>
                    <td>{item?.nilaiakhir3 || "-"}</td>

                    {/* Kesimpulan */}
                    <td>{item?.nilaiakhir4 || "-"}</td>
                    <td>{item?.kesimpulan || "-"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={34}>Tidak Ada Data</td>
                </tr>
              )}
            </tbody>
          </>
        );
    }
  };

  let levelName = "";
  if (currentLevel === UserLevel.National) {
    levelName = "Nasional";
  } else if (currentLevel === UserLevel.Province) {
    levelName = "Provinsi";
  } else if (currentLevel === UserLevel.District) {
    levelName = "Kabupaten/Kota";
  } else if (currentLevel === UserLevel.BKKInduk) {
    levelName = "BKK Induk";
  } else if (currentLevel === UserLevel.BKKWilker) {
    levelName = "BKK Wilker";
  } else {
    levelName = "Fasyankes";
  }

  const isBkkLevel =
    currentLevel === UserLevel.BKKInduk ||
    currentLevel === UserLevel.BKKWilker;

  let data = reportInfo?.fasyankes;
  let parts = data?.split(",");
  let faskesName = parts?.map(function (part) {
    return part?.split("|")[1];
  });
  let result = faskesName?.join(", ");

  const indukName = reportInfo?.induk?.split("|")[1];
  const wilkerNames = reportInfo?.wilker
    ?.split(",")
    .map((part) => part?.split("|")[1])
    .filter(Boolean)
    .join(", ");

  return (
    <div
      className="table-table-responsive"
      ref={tableRef}
    >
      <table>
        <tbody>
          <tr style={{ border: "none", padding: 0 }}>
            <th style={{ border: "none", paddingBottom: "0" }}>
              <h3>SISMAL v4, Laporan Mikroskopis Fasyankes/BKK</h3>
            </th>
          </tr>
        </tbody>
      </table>
      <table>
        <tbody>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Level
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              : {levelName}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Provinsi
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              :{" "}
              {!reportInfo?.province
                ? "Semua Provinsi"
                : reportInfo?.province?.split("|")[1]}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Kab/Kota
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              :{" "}
              {!reportInfo?.district
                ? "Semua Kab/Kota"
                : reportInfo?.district?.split("|")[1]}
            </th>
          </tr>
          {!isBkkLevel && (
            <tr style={{ border: "none" }}>
              <th style={{ border: "none", paddingTop: 0 }}>Fasyankes/BKK</th>
              <th style={{ border: "none", paddingTop: 0 }}>
                : {!reportInfo?.fasyankes ? "Semua Fasyankes/BKK" : result}
              </th>
            </tr>
          )}
          {isBkkLevel && (
            <tr style={{ border: "none" }}>
              <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
                BKK Induk
              </th>
              <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
                : {indukName || "Semua BKK Induk"}
              </th>
            </tr>
          )}
          {currentLevel === UserLevel.BKKWilker && (
            <tr style={{ border: "none" }}>
              <th style={{ border: "none", paddingTop: 0 }}>BKK Wilker</th>
              <th style={{ border: "none", paddingTop: 0 }}>
                : {wilkerNames || "Semua BKK Wilker"}
              </th>
            </tr>
          )}
        </tbody>
      </table>
      <table>{renderTableByLevel()}</table>
    </div>
  );
};

export default TableComponent;
